import React from "react"
import Home from "@views/home"
import SEO from "@components/SEO"

const IndexPage = () => (
  <div>
    <SEO
      title="EngineID - Home"
      keywords={[
        `engineid`,
        `security`,
        `access to your applications`,
        `password management`,
        `provision to cloud`,
        `permission management`,
        `single sign on`,
        `identity management`,
        `access management`,
      ]}
    />
    <Home />
  </div>
)

export default IndexPage
